//src/pages/REG/REG420F1.jsx
import React, {useContext, useEffect, useState} from 'react';
import style from "./REG420F1.module.scss";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import styleCom from "./REGCOM.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";
import DataGrid from "../../components/DataGrid/DataGrid";




// 페이지 시작
const REG420F1 = ({navBar: NavBar, isActive}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]);

    const [isComCodeReady, setIsComCodeReady] = useState(false);    //검색조건
    const [isManager, setIsManager] = useState(false);    //관리자 역할


    const searchObj = [
        { name:"hsptCd", value:  userInfo.hsptCd},
        { name:"studyPid", value: ''},
        { name:"fromDt", value: ''},
        { name:"toDt", value: ''}
    ];
    const [inputData, setInputData]  = useState(searchObj);

    const [rows_cartBpList, setRows_cartBpList] = useState([]);
    const cols_cartBpList = [
         { key: 'studyPid', name: '등록번호',   width: '10%' }
        ,{ key: 'cartTime', name: '일시(CART BP)',   width: '10%' }
        ,{ key: 'sbp',    name: 'SBP(mmHg)', width: '20%' }
        ,{ key: 'dbp',    name: 'DBP(mmHg)', width: '20%' }
        ,{ key: 'mbp',    name: 'MBP(mmHg)', width: '20%' }
        ,{ key: 'pulse',  name: 'Pulse',     width: '20%' }
    ];

    //form load
    useEffect(() => {
        const fetchComCode = async () => {
            await getComDtlsData(); // 비동기 처리 가정
            setIsComCodeReady(true);
        };
        fetchComCode();

    }, []);

    // 화면 활성시 조회기능
    // useEffect(() => {
    //     if (isComCodeReady && isActive) {
    //         getCartBpList();
    //     }
    // }, [isComCodeReady, isActive]);


/*  ====================================================================================================*/
    //데이터 get, set
    const setItemValue = (name, value) => {
        setInputData(prevData =>
            prevData.map(item =>
                item.name === name && item.value !== value ? { ...item, value } : item
            )
        );
    };
    const getItemValue = (getName) =>{
        return inputData.find(item => item.name === getName).value;
    }
    //조회 버튼 클릭
    const handleClick_search = (e) => {
        getCartBpList();
    }

    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };

    /* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setItemValue("hsptCd", userInfo.hsptCd);
    }

    /* 데이터 조회  
    * 
    * */    
    async function getCartBpList(){
        //메인 데이터 조회
        const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
        const res = await postData("/RED/getCartBpDataList", getParam);
        setRows_cartBpList(res);
    }
    
    
    return (
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "78px", height: "40px"}}
                            onClick={handleClick_search}>
                        조회
                    </Button>
                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr style={{alignContent: "center"}}>
                        <td className={style.content_typ1}>
                            연구기관
                        </td>
                        <td className={style.content_typ1}>
                            <SelectBox options={comHsptObj} value={getItemValue("hsptCd")}
                                       width={230}
                                       onChange={(value) => setItemValue("hsptCd", value)}
                                       isAllExpr={false}/>
                        </td>
                        <td className={style.content_typ1}> 일(CART BP)</td>
                        <td className={style.content_typ1}>
                            <div className={style.content_typ2}>
                                <DatePicker selDate={ymdToDate(getItemValue('fromDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('fromDt', dateToYMD(date))}/>
                                {insertSpace(2)}~{insertSpace(2)}
                                <DatePicker selDate={ymdToDate(getItemValue('toDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('toDt', dateToYMD(date))}/>
                            </div>
                        </td>
                        <td className={style.content_typ1}> 등록번호</td>
                        <td className={style.content_typ1}>
                            <InputUnitText type={"text"} value={getItemValue('studyPid')} unit={""}
                                           onChange={(value) => setItemValue('studyPid', value)}/>
                        </td>

                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>
            <div className={styleCom.root_wrap} style={{height: "100%", overflowY: "scroll"}}>
                <div className={styleCom.title_wrap}>
                    <h3>Subject List</h3>
                </div>
                <div style={{marginTop: "10px"}}>
                    <DataGrid
                        cols={cols_cartBpList}
                        rows={rows_cartBpList}
                        rowHeight={37}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>
            </div>
            
        </main>


    )
        ;
};


export default REG420F1;
